import script from "./CardInfoReserva.vue?vue&type=script&setup=true&lang=js"
export * from "./CardInfoReserva.vue?vue&type=script&setup=true&lang=js"

import "./CardInfoReserva.vue?vue&type=style&index=0&id=9ee4f432&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ee4f432"]])

export default __exports__